// src/api/kanban.js
import axios from 'axios'

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '/neue/admin',
  headers: { 'Content-Type': 'application/json' },
})

// — attach token to every request
apiClient.interceptors.request.use(config => {
  const token = localStorage.getItem('auth_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}, err => Promise.reject(err))

// — catch 401s and force relogin
apiClient.interceptors.response.use(
  resp => resp,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)


export async function purchaseLabel(card) {
  const res = await apiClient.post('/neue/admin/labels/purchase', card)
  return res.data
}

export async function getRates(shipping, items, parcel = null, insuranceAmount = 0) {
  const res = await apiClient.post('/neue/admin/labels/rates', {
    shipping,
    items,
    parcel,
    insuranceAmount
  })
  return res.data
}

export async function fetchProducts() {
  const res = await apiClient.get('/neue/admin/labels/products')
  return res.data.products
}

export async function fetchParcels() {
  const res = await apiClient.get('/neue/admin/labels/parcels')
  return res.data.parcels
}

export async function fetchLabels() {
  const res = await apiClient.get('/neue/admin/labels')
  // User reported this endpoint now returns sender info object, not array.
  // For now, return as is or handle? 
  // If it's an object, wrapping it in array might prevent crash but logic is wrong.
  return res.data
}

export async function fetchSenderInfo() {
  const res = await apiClient.get('/neue/admin/labels')
  return res.data
}

export async function voidLabel(id) {
  const res = await apiClient.post(`/neue/admin/labels/${id}/void`)
  return res.data
}

export async function createProduct(productData) {
  const res = await apiClient.post('/neue/admin/labels/products', productData)
  return res.data
}

export async function updateProduct(id, productData) {
  const res = await apiClient.put(`/neue/admin/labels/products/${id}`, productData)
  return res.data
}